import { Fertilizer, FertilizerFromDelivery } from 'src/app/fertilizers/models/fertilizer.model';

import { createUninitializedResource, ExternalResource } from '../../shared/models/resource.models';
export interface ManureSpaceState {
  manureSpace: ExternalResource<ManureSpace>;
  manureSpaceFilteredByManureCode?: ExternalResource<ManureSpace>;
  fertilizersFromDelivery?: FertilizerFromDelivery[] | null;
  manureSpaceByPeriod?: ExternalResource<ManureSpace>;
  activeTabIndex: ManureTabType;
}

export interface ManureSpace {
  id: number;
  customerId: number;
  cropYear: number;
  cropFieldIds: number[];
  comment: string;
  initialStockMatchesRvo: boolean;
  fertilizers: Fertilizer[];
}

export interface ParamsImportFertilizers {
  deliveriesFrom: string;
  deliveriesUntil: string;
}

export enum ManureTabType {
  ManureType = 0,
  ManurePeriod = 1,
  ManureDetails = 2,
}

export const InitialManureSpaceState: ManureSpaceState = {
  fertilizersFromDelivery: null,
  manureSpace: createUninitializedResource(),
  manureSpaceFilteredByManureCode: createUninitializedResource(),
  manureSpaceByPeriod: createUninitializedResource(),
  activeTabIndex: ManureTabType.ManureType,
};
